import axiosClient from "../axiosClient";
import { AUTHORIZEDDEALER_URL,TENANTCREATE_URL,TENANTEDIT_URL,TENANTALL_URL,TENANTID_URL,TENANTDELETE_URL, 
    ROLECREATE_URL,ROLEEDIT_URL,ROLEID_URL,ROLEDELETE_URL,ROLEALL_URL,USERALL_URL,USERDELETE_URL,
    TENANTALLGS_URL,
    USERBRANCH_URL,USERID_URL,USEREDIT_URL,USERCREATE_URL,
    FUNCTIONALEDIT_URL,
    FUNCTIONALCREATE_URL,
    FUNCTIONALID_URL,
    FUNCTIONALDELETE_URL,
    FUNCTIONALALL_URL,
    FEATUREDELETE_URL,
    FEATUREALL_URL,
    FEATUREID_URL,
    FEATURECREATE_URL,
    FEATUREEDIT_URL,
    FEATURECREATENEW_URL,
    FEATUREIDNEW_URL,
    FUNCTIONALALLNEW_URL,
    GETROUTER_URL,
    FEEDBACK,
    FEEDBACKALL,
    FEEDBACKDOWNLOAD,
    REPORTCREATE_URL,
    REPORTEDIT_URL,
    REPORTID_URL,
    REPORTDELETE_URL,
    REPORTEALL_URL,
    REPORTFEATUREIDNEW_URL,
    REPORTFEATURECREATENEW_URL,
    REPORTROLEIDNEW_URL,
    REPORTCATEGORY_URL,
    REPORTGENERATION_URL
} from "../endpoints";

export const adminService = {
    fetchDealers: async () => {
        try {
            const response = await axiosClient.get(AUTHORIZEDDEALER_URL);
            return response.data;
          } catch (error) {
            throw new Error('Failed to fetch dealer categories');
          }
    },
    tenantAll: async () => {
        try {
            const response = await axiosClient.get(TENANTALL_URL);
            return response.data;
          } catch (error) {
            throw new Error('Failed to fetch dealer categories');
          }
    },
    tenantAllGS: async () => {
        try {
            const response = await axiosClient.get(TENANTALLGS_URL);
            return response.data;
          } catch (error) {
            throw new Error('Failed to fetch dealer categories');
          }
    },
    tenantByID: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.get(`${TENANTID_URL}/${id}`); // Corrected
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to fetch tenant details:", error);
          throw new Error("Failed to fetch tenant details");
        }
      },
      tenantDeleteByID: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.delete(`${TENANTDELETE_URL}/${id}`); // Corrected
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
            console.error("Failed to Delete Tenant:", error);
            throw new Error("Failed to Delete Tenant");
        }
      },
      
    
      tenantcreate: async (requestData: {
        authorizedDealerId: string;
        name: string;
        domain: string;
        connectionString: string;
        companyName: string;
        legalName: string;
        taxId: string;
        address1: string;
        address2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        phone: string;
        email: string;
      }) => {
        try {
          const response = await axiosClient.post(TENANTCREATE_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Create operation failed");
        }
      },
      tenantedit: async (request: {
        authorizedDealerId: string;
        name: string;
        domain: string;
        connectionString: string;
        companyName: string;
        legalName: string;
        taxId: string;
        address1: string;
        address2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        phone: string;
        email: string;
      }) => {
        try {
          const response = await axiosClient.post(TENANTEDIT_URL, request); // Send directly
          return response.data;
        } catch (error) {
          console.error("Edit request failed:", error);
          throw new Error("Edit request failed");
        }
      },
      roleCreate : async (requestData: { name: string }) => {
        try {
          const response = await axiosClient.post(ROLECREATE_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Role creation failed");
        }
      },
      roleupdate: async (id: string, roleData: { name: string }) => {
        try {
          console.log(`Calling API to update role with ID: ${id}`, roleData); // ✅ Debug log
    
          const response = await axiosClient.post(`${ROLEEDIT_URL}/${id}`, roleData); 
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to update role:", error);
          throw new Error("Failed to update role");
        }
      },
      roleById: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${ROLEID_URL}/${id}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch role details:", error);
          throw new Error("Failed to fetch role details");
        }
      },
      roleDeleteByID : async (id: string) => {
        try {
          console.log(`Calling API to delete role with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.delete(`${ROLEDELETE_URL}${id}`); // Corrected
      
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to Delete Role:", error);
          throw new Error("Failed to Delete Role");
        }
      },
      roleAll: async () => {
        try {
          const response = await axiosClient.get(ROLEALL_URL);
          console.log("API Response:", response.data); // Debugging output
          return { data: response.data }; // Wrap response in an object if needed
        } catch (error) {
          throw new Error("Failed to fetch roles");
        }
      },
      userAll: async () => {
        try {
          const response = await axiosClient.post(USERALL_URL);
          console.log("API Response:", response.data); // Debugging output
          return { data: response.data }; // Wrap response in an object if needed
        } catch (error) {
          throw new Error("Failed to fetch User");
        }
      },
      userDeleteByID : async (id: string) => {
        try {
          console.log(`Calling API to delete User with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.delete(`${USERDELETE_URL}/${id}`); // Corrected
      
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to Delete User:", error);
          throw new Error("Failed to Delete User");
        }
      },
      branchByTenant: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.post(USERBRANCH_URL, { tenantId: id }); // Pass ID in the body
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Branch details:", error);
          throw new Error("Failed to fetch Branch details");
        }
      },
      userById: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${USERID_URL}/${id}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch User details:", error);
          throw new Error("Failed to fetch User details");
        }
      },
      userCreate : async (requestData: { name: string }) => {
        try {
          const response = await axiosClient.post(USERCREATE_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("User creation failed");
        }
      },
      userupdate: async (id: string, roleData: { name: string }) => {
        try {
          console.log(`Calling API to update role with ID: ${id}`, roleData); // ✅ Debug log
    
          const response = await axiosClient.post(`${USEREDIT_URL}/${id}`, roleData); 
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to update User:", error);
          throw new Error("Failed to update User");
        }
      },
      functionalupdate: async (id: string, functionalData: { functionalname: string }) => {
        try {
          console.log(`Calling API to update role with ID: ${id}`, functionalData); // ✅ Debug log
    
          const response = await axiosClient.post(`${FUNCTIONALEDIT_URL}/${id}`, functionalData); 
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to update Functional:", error);
          throw new Error("Failed to update Functional");
        }
      },
      functionalCreate : async (requestData: { functionalname: string }) => {
        try {
          const response = await axiosClient.post(FUNCTIONALCREATE_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Functional creation failed");
        }
      },
      functionalById: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${FUNCTIONALID_URL}/${id}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Functional details:", error);
          throw new Error("Failed to fetch Functional details");
        }
      },
      functionalAll: async () => {
        try {
          const response = await axiosClient.get(FUNCTIONALALL_URL);
          console.log("API Response:", response.data);
          return response.data; // Remove extra wrapping
        } catch (error) {
          throw new Error("Failed to fetch Functional");
        }
      },
      functionalAllNew: async  (requestData: { RoleIds: string[] }) => {
        try {
          const response = await axiosClient.post(FUNCTIONALALLNEW_URL,requestData);
         
          console.log("API Response:", response.data);
          return response.data;
        } catch (error) {
          throw new Error("Failed to fetch Functional");
        }
      },
      
      functionalDeleteByID : async (id: string) => {
        try {
          console.log(`Calling API to delete User with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.delete(`${FUNCTIONALDELETE_URL}/${id}`); // Corrected
      
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to Delete Functional:", error);
          throw new Error("Failed to Delete Functinal");
        }
      },

      featureupdate: async (id: string, featureData: { FeatureName: string }) => {
        try {
          console.log(`Calling API to update role with ID: ${id}`, featureData); // ✅ Debug log
    
          const response = await axiosClient.post(`${FEATUREEDIT_URL}/${id}`, featureData); 
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to update Functional:", error);
          throw new Error("Failed to update Functional");
        }
      },
      featureCreate : async (requestData: { FeatureName: string }) => {
        try {
          const response = await axiosClient.post(FEATURECREATE_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Feature creation failed");
        }
      },
      featureById: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${FEATUREID_URL}/${id}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Feature details:", error);
          throw new Error("Failed to fetch Feature details");
        }
      },
      featureAll: async () => {
        try {
          const response = await axiosClient.get(FEATUREALL_URL);
          console.log("API Response:", response.data);
          return response.data; // Remove extra wrapping
        } catch (error) {
          throw new Error("Failed to fetch Feature");
        }
      },
      
      featureDeleteByID : async (id: string) => {
        try {
          console.log(`Calling API to delete User with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.delete(`${FEATUREDELETE_URL}/${id}`); // Corrected
      
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to Delete Feature:", error);
          throw new Error("Failed to Delete Feature");
        }
      },
      functionalCreateNew: async (requestData: { roleId: string; permissions: { featureId: string; assign: boolean; create: boolean; edit: boolean; delete: boolean; view: boolean; print: boolean; }[] }) => {
        try {
          const response = await axiosClient.post(FEATURECREATENEW_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Functional creation failed");
        }
      },
      featureByIdNew: async (roleId: string) => {
        try {
          console.log(`Calling API with ID: ${roleId}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${FEATUREIDNEW_URL}/${roleId}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Feature details:", error);
          throw new Error("Failed to fetch Feature details");
        }
      },
      routerById: async (requestData: { roleIds: string[] }) => {
        try {
          const response = await axiosClient.post(GETROUTER_URL, requestData);
          console.log("API Response:", response.data); // Debug log
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Feature details:", error);
          throw new Error("Failed to fetch Feature details");
        }
      },
      feedbacksubmit: async (requestData: FormData) => {
        try {
          const response = await axiosClient.post(FEEDBACK, requestData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
    
          return response.data;
        } catch (error) {
          console.error("Error in feedback submission:", error);
          throw new Error("Feedback submission failed");
        }
      },
      feedbackAll: async () => {
        try {
          const response = await axiosClient.get(FEEDBACKALL);
          console.log("API Response:", response.data);
          return response.data; // Remove extra wrapping
        } catch (error) {
          throw new Error("Failed to fetch Feedback");
        }
      },
      feedbackdownloadFile: async (filePath: string): Promise<Blob> => {
        try {
          const response = await axiosClient.get(FEEDBACKDOWNLOAD, {
            params: { filePath },
            responseType: "blob", // Important for file downloads
          });
    
          return response.data;
        } catch (error) {
          console.error("Failed to download file", error);
          throw new Error("Failed to download file");
        }
      },
    
reportCreate : async (requestData: { name: string }) => {
        try {
          const response = await axiosClient.post(REPORTCREATE_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Role creation failed");
        }
      },
      reportupdate: async (id: string, roleData: { name: string }) => {
        try {
          console.log(`Calling API to update role with ID: ${id}`, roleData); // ✅ Debug log
    
          const response = await axiosClient.post(`${REPORTEDIT_URL}/${id}`, roleData); 
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to update role:", error);
          throw new Error("Failed to update role");
        }
      },
      reportById: async (id: string) => {
        try {
          console.log(`Calling API with ID: ${id}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${REPORTID_URL}/${id}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch role details:", error);
          throw new Error("Failed to fetch role details");
        }
      },
      reportDeleteByID : async (id: string) => {
        try {
          console.log(`Calling API to delete role with ID: ${id}`); // ✅ Debug log
      
          const response = await axiosClient.delete(`${REPORTDELETE_URL}${id}`); // Corrected
      
          console.log("API Response:", response.data); // ✅ Debug log
      
          return response.data;
        } catch (error) {
          console.error("Failed to Delete Role:", error);
          throw new Error("Failed to Delete Role");
        }
      },
      reportAll: async () => {
        try {
          const response = await axiosClient.get(REPORTEALL_URL);
          console.log("API Response:", response.data); // Debugging output
          return { data: response.data }; // Wrap response in an object if needed
        } catch (error) {
          throw new Error("Failed to fetch roles");
        }
      },
      reportfeatureByIdNew: async (roleId: string) => {
        try {
          console.log(`Calling API with ID: ${roleId}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${REPORTFEATUREIDNEW_URL}/${roleId}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Feature details:", error);
          throw new Error("Failed to fetch Feature details");
        }
      },
      reportfeatureCreateNew: async (requestData: { roleId: string; permissions: { reportId: string; assign: boolean; csv: boolean; excel: boolean; pdf: boolean; print: boolean; }[] }) => {
        try {
          const response = await axiosClient.post(REPORTFEATURECREATENEW_URL, requestData);
          return response.data; // Returns response data
        } catch (error) {
          throw new Error("Functional creation failed");
        }
      },
      reportroleByIdNew: async (roleId: string) => {
        try {
          console.log(`Calling API with ID: ${roleId}`); // ✅ Debug log
    
          const response = await axiosClient.get(`${REPORTROLEIDNEW_URL}/${roleId}`);
          console.log("API Response:", response.data); // ✅ Debug log
    
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Feature details:", error);
          throw new Error("Failed to fetch Feature details");
        }
      },
      reportCategory: async (roleId: string, params: { category: string }) => {
        try {
          const response = await axiosClient.get(`${REPORTCATEGORY_URL}/${roleId}`, {
            params
          });
      
          console.log("API Response:", response.data); // ✅ Debug log
          return response.data;
        } catch (error) {
          console.error("Failed to fetch Feature details:", error);
          throw new Error("Failed to fetch Feature details");
        }
      },
      
      reportgeneration: async (data: any) => {
        const response = await axiosClient.post(REPORTGENERATION_URL, data); // ← send data directly
        return response.data.data.records;
      },
      
}
